var totalDistance = 0;
var cursorX, cursorY;

$(document).on('mousemove', function(e) {

    // dynamically add animate attributes to intro block (for underline/arrow animation)
    if ( $('#industriesBlock').length ) {
        $('.block-intro:first-of-type .heading-big .text-underline-heading')
            .attr({'data-animate': 'industriesSuccess', 'data-arrow-target': 'arrowTarget'})
            .addClass('js-industries-arrow-src');
    }

    if ($(window).width() >= 1200) {
 
        // check if 15 elements are visible
        if ($('#industriesCircle .circle-item.is-visible').length != 15) {

            // mouse moving
            var cursorThreshold = 100;
    
            if (cursorX) totalDistance += Math.sqrt(Math.pow(cursorY - e.clientY, 2) + Math.pow(cursorX - e.clientX, 2));
            if (totalDistance >= cursorThreshold) {

                visibleElement();

                totalDistance = 0;
            }
            
            cursorX = e.clientX;
            cursorY = e.clientY;

        } else {
            industriesLeaderCompleted();

            // scroll user down the page after animation has completed
            // setTimeout(function() { 
            //     $('html, body').animate({
            //         scrollTop: $('#industriesBlock').offset().top + 400
            //     }, 500);
            // }, 3500);
        }

    }
});


// toggle blue label once 15 circles have been selected
function industriesLeaderCompleted() {
    $(document).off('mousemove');

    $('#industryLabel')
        .html('learns from')
        .addClass('industry-label-client')
        .removeClass('industry-label');


    setTimeout(function() { 
        $('.js-industry-label').addClass('is-visible');
    }, 1000);

    // fade out frosted background after all items are displayed
    setTimeout(function() { 
        $('.leader-image-container').addClass('overlay-hidden');
        $('#industriesCircle .circle-item').addClass('is-completed');
        $('.js-industries-arrow').addClass('is-visible');
    }, 1500);

    // fade in underline
    setTimeout(function() {
        $('[data-animate="industriesSuccess"]')
            .append('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-underline-heading.svg" height="15" width="415">Hand drawn underline</object>')
    }, 5800);
}


// complete animation after scrolling down the page
$(window).scroll(function() {
    industriesLeader = $('#industriesBlock');

    if ($(window).width() >= 992 && industriesLeader.length) {
        if ($(this).scrollTop() > 200) {
            industriesLeaderCompleted();

            setTimeout(function() {
                $('.industries-block .circle-title')
                    .addClass('has-scrolled')
            }, 1500);
        }
    }
});


// Industries
let industries = [
    "Healthcare",
    "Media & Entertainment",
    "Pharma",
    "Private Equity",
    "Public Sector",
    "Retail",
    "Social Sector",
    "Tech",
    "Telecom",
    "Heavy Industry",
    "Travel",
    "Automotive",
    "Consumer Goods",
    "Financial Services",
    "Food & Beverage"
];
let stepIndex = 0;

// shuffle industries array
function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // while there remain elements to shuffle
  while (currentIndex != 0) {

    // pick a remaining element
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // swap it with the current element
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}
let industriesRandom = shuffle(industries);

// adds learns from to array
let newStepArray = [];

// grab title from industry
var industryDataTitle = $('#industryLabel').attr('data-title');

// adds "learn more' after every other industry
for(let i = 0; i < industries.length; i++) {
    if((i + 0) !== industries.length) {
        newStepArray.push(industries[i]);
        newStepArray.push(industryDataTitle);
    }
}

function visibleElement() {
    let activeStep = newStepArray[stepIndex];

    // industry label
    var industryLabel = $("#industriesCircle .circle-item.industry-" + stepIndex).attr('data-title');

    var industryTarget = $('.js-circle-element[data-title="' + activeStep + '"]');
    industryTarget.addClass('is-visible');

    $('#industryLabel').html(activeStep);

    //var labelTarget = $('#industryLabel').html();

    if ($('#industryLabel').html() == ('learns from')) {
        $('#industryLabel')
            .addClass('industry-label-client')
            .removeClass('industry-label');
    } else {
        $('#industryLabel')
            .addClass('industry-label')
            .removeClass('industry-label-client')
    }

    stepIndex++;
}
